/**
 * Vue Filter - ID Mask
 */

export default function idMask(val, prefix = '', limit = 12) {
	if (!val) return val

	return `${prefix}${val}`.substring(0, limit)
}
